import React from 'react';
import { CertificateGenerationDocumentId } from '~/store/covenants/types.ts';
import { FinancialConditionDocumentGenerationForm } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/FinancialConditionDocumentGenerationForm.tsx';
import { IncomeStructureByKvedDocumentGenerationForm } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/incomeStructureByKved/IncomeStructureByKvedDocumentGenerationForm.tsx';
import { StateAidReceivedDocumentGenerationForm } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/StateAidReceivedDocumentGenerationForm.tsx';
import type { TDocumentGenerationFormProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/types.ts';

interface IDocumentGenerationFormProps extends TDocumentGenerationFormProps {
  documentId: string | number;
}

const DOCUMENT_GENERATION_FORMS: Record<string, React.FC<TDocumentGenerationFormProps>> = {
  [CertificateGenerationDocumentId.FinancialCondition]: FinancialConditionDocumentGenerationForm,
  [CertificateGenerationDocumentId.IncomeStructureByKved]:
    IncomeStructureByKvedDocumentGenerationForm,
  [CertificateGenerationDocumentId.StateAidReceived]: StateAidReceivedDocumentGenerationForm,
};

export const DocumentGenerationForm: React.FC<IDocumentGenerationFormProps> = ({
  documentId,
  ...props
}) => {
  const GenerationForm = DOCUMENT_GENERATION_FORMS[String(documentId)];

  return GenerationForm ? <GenerationForm {...props} /> : null;
};
